import { render, staticRenderFns } from "./HeadProjectedTotal.vue?vue&type=template&id=40e9b989"
import script from "./HeadProjectedTotal.vue?vue&type=script&lang=js"
export * from "./HeadProjectedTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports